module.exports = __webpack_public_path__ + "img/gamblers-anonymous.514ff81c.png";